<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CdSvGr/tc-custom/9781504095419.jpg?1730582468568" alt="This image is the cover for the book Particular Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Particular Man
      </h1>
      <p class="bookDescription body article font2">
        <b>Love never dies in this novel by “a writer of addictive emotional thrillers” (<i>The Independent</i>).</b><br/><br/> Told from three perspectives <i>A Particular Man</i> is about love, truth and the unpredictable consequences of loss.<br/><br/> When Edgar dies in a Far East prisoner of war camp it breaks the heart of fellow prisoner Starling. In Edgar’s final moments, Starling makes him a promise. When, after the war, he visits Edgar’s family to fulfill this promise, Edgar's mother Clementine mistakes him for another man. <br/><br/> Her mistake allows him access to Edgar’s home and to those who loved him, stirring powerful and disorientating emotions, and embroiling him in a web of deceit.<br/><br/> The loss has driven his sister Aida to seek solace in the arms of a series of men—but the meeting with Starling sparks a complex connection, fueled by their mutual longing for Edgar.<br/><br/> Meanwhile Clementine, also grieving for Edgar, has secrets of her own…<br/><br/> “One of Britain’s finest novelists.” —<i>The Sunday Telegraph</i><br/><br/> “[Glaister] commands respect for writing novels which are not just dark and mysterious but also emotionally satisfying.” —<i>The Times Literary Supplement</i><br/><br/> “An expert plotter.” —<i>The Scotsman</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lesley Glaister
      </h2>
      
      <p class="authorDescription body article">Lesley Glaister&#160;(b. 1956) is a British novelist, playwright, and teacher of writing, currently working at the University of St Andrews. She is a fellow of the Royal Society of Literature and a member of the Society of Authors. Her first novel,&#160;<I>Honour Thy Father</I>, was published in 1990 and received both a Somerset Maugham Award and a Betty Trask Award. Glaister became known for her darkly humorous works and has been dubbed the Queen of Domestic Gothic. Glaister was named Yorkshire Author of the Year in 1998 for her novel&#160;<I>Easy Peasy</I>, which was shortlisted for the Guardian&#160;Fiction Award in 1998.&#160;<I>Now You See Me&#160;</I>was shortlisted for the Orange Prize for Fiction in 2002. Glaister lives in Edinburgh, Scotland, with her husband, author Andrew Greig.<BR /> &#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?817deb4a